import React from 'react';
import { SvgIcon } from './utils/SvgIcon.js';
import type { SvgIconT } from './utils/react-desc-prop-types.js';

const Spacer = (props: SvgIconT.Props) => (
  <SvgIcon width={24} height={24} {...props} viewBox="0 0 24 24">
    <path
      fill-rule="nonzero"
      d="M5.825 8.12a.5.5 0 0 1 .055.705L3.587 11.5h15.826L17.12 8.825a.5.5 0 0 1 .76-.65l3 3.5a.5.5 0 0 1 0 .65l-3 3.5a.5.5 0 1 1-.76-.65l2.293-2.675H3.587l2.293 2.675a.5.5 0 1 1-.76.65l-3-3.5a.5.5 0 0 1 0-.65l3-3.5a.5.5 0 0 1 .705-.055Z"
    />
  </SvgIcon>
);

export default Spacer;
